import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DevExpressModule } from '../../devexpress.module';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, DashboardRoutingModule, DevExpressModule, SharedModule, TranslateModule],
  declarations: [DashboardComponent],
  providers: [],
})
export class DashboardModule {}
